<div class="header-container">

    <div class="header-left">
        <div class="brand-logo">
            <img src="/assets/roche_blue.svg" alt="Roche" class="roche-logo" />
            <span class="brand-text">Study Design Hub</span>
        </div>

        <div class="vertical-divider"></div>

        <div class="title-wrapper d-flex gap-2 align-items-center">
            <div class="project-title">{{ title }}</div>

            <div class="title-separator mt-2">•</div>

            <div class="project-title link">
                {{ scenarioTitle }}
            </div>
        </div>
    </div>



    <div class="header-action-container">

        <div class="structured-view-chip active-users-chip" *ngIf="activeUsers.length">
            <span class="role-text"><b>Online:</b></span>
            <div class="active-users-avatars">
                <span class="active-user-avatar" *ngFor="let user of visibleActiveUsers"
                    [rdsTooltip]="user.fullName" rdsTooltipPosition="bottom-center">{{ user.initials }}</span>
                <span class="active-user-avatar active-user-more" *ngIf="hiddenActiveUsersCount > 0"
                    [rdsTooltip]="hiddenActiveUsersLabel" rdsTooltipPosition="bottom-center">+{{ hiddenActiveUsersCount }}</span>
            </div>
        </div>

        <div class="structured-view-chip role-btn">
            <span class="role-text"><b>Your role:</b> {{ user_role | titlecase }}</span>
        </div>

        <div *ngIf="showShareButton" class="btn-share-wrapper">
            <button rds-primary-button class="btn-share"
                [class.round-button-icon-only]="isSidePanelOpen"
                [rdsTooltip]="isSidePanelOpen ? 'Share' : ''"
                (click)="openShareDialog()">
                <rds-icon namespace="filled" icon="user_add"></rds-icon>
                @if (!isSidePanelOpen) {
                Share
                }
            </button>
        </div>

        <button rds-secondary-button class="btn-back-to-workspace" (click)="redirectToScenario()"
            [class.round-button-icon-only]="isSidePanelOpen"
            [rdsTooltip]="isSidePanelOpen ? 'Back to Workspace' : ''">
            <rds-icon icon="arrow_left"></rds-icon>
            @if (!isSidePanelOpen) {
            Back to Workspace
            }
        </button>

        <div class="avatar-menu-container">
            <rds-avatar (click)="toggleAvatarMenu()">
                <span rds-avatar-initials>{{ avatarInitials }}</span>
            </rds-avatar>

            <div class="avatar-menu" *ngIf="isAvatarMenuOpen">
                <button class="menu-item" (click)="openProfileSettings($event)">
                    <rds-icon namespace="outlined" icon="settings" />
                    Profile Settings
                </button>
                <button class="menu-item" (click)="openHelp()">
                    <rds-icon namespace="outlined" icon="circle_help" />Help
                </button>
                <button class="menu-item" (click)="openGSite()">
                    <img src="assets/gSuite.png" alt="gSite" />
                    gSite
                </button>
                <button class="menu-item logout" (click)="logout()">
                    <rds-icon namespace="outlined" icon="logoff" />
                    Logout
                </button>
            </div>
        </div>
    </div>
</div>